import { gql } from '@apollo/client';
import {
  ID_NAME_FIELDS,
  USER_BASIC_FIELDS,
  ID_NAME_WEBSITE_LOGO_FIELDS,
  PROPERTY_MAIN_FIELDS,
} from 'graphql/common/fragments';
import { PROPERTY_SET_FRAGMENT } from 'graphql/propertySet/fragments';
import { PROJECT_LINK_FRAGMENT } from 'graphql/projects';

export const GET_PROPERTY_SET_QUERY = gql`
  query getPropertySet($id: ID!) {
    propertySet(id: $id) {
      ...propertySetAttributes
    }
  }
  ${PROPERTY_SET_FRAGMENT}
`;

export const GET_PROPERTY_SETS_QUERY = gql`
  query getPropertySets($search: PropertySetSearchInput!) {
    propertySets(search: $search) {
      id
      name
      type
      properties {
        columnSpacingMax
        columnSpacingMaxMt
        columnSpacingMin
        columnSpacingMinMt
        featured
        id
        name
        primaryAddress
        displayAddress
        latitude
        longitude
        latitudeDisplay
        longitudeDisplay
        coverMediaUrl
        coverMediaType
        market {
          ${ID_NAME_FIELDS}
        }
        submarket {
          ${ID_NAME_FIELDS}
        }
        micromarket {
          ${ID_NAME_FIELDS}
        }
      }
      user {
        ${USER_BASIC_FIELDS}
        profileImageUrl
      }
      sharedUsers {
        id
        firstName
        lastName
        email
        profileImageUrl
      }
      userId
      targetProperty {
        ${PROPERTY_MAIN_FIELDS}
        amenities {
          ${ID_NAME_FIELDS}
        }
        leasingCompany {
          ${ID_NAME_WEBSITE_LOGO_FIELDS}
        }
        managementCompany {
          ${ID_NAME_WEBSITE_LOGO_FIELDS}
        }
        office {
          typicalCeilingHeightFeet
          typicalCeilingHeightInches
          typicalCeilingHeightMt
        }
        owners {
          ${ID_NAME_FIELDS}
        }
        market {
          ${ID_NAME_FIELDS}
        }
        submarket {
          ${ID_NAME_FIELDS}
        }
        propertyClass {
          ${ID_NAME_FIELDS}
        }
        propertyType {
          ${ID_NAME_FIELDS}
        }
      }
      targetTenant {
        ${ID_NAME_WEBSITE_LOGO_FIELDS}
        headquarters
        logoId
        industry {
          ${ID_NAME_FIELDS}
        }
      }
      createdAt
      metadata {
        propertySetId
        propertyId
        availabilitiesCount
        rentRangeMin
        rentRangeMax
        sizeRangeMin
        sizeRangeMinMt
        sizeRangeMax
        sizeRangeMaxMt
      }
      projects {
        ...projectLink
      }
    }
  }
  ${PROJECT_LINK_FRAGMENT}
`;
